import Vue from 'vue'
import VueRouter from 'vue-router'
import VueAnalytics from 'vue-analytics'
import App from './App.vue'

import { store } from './store/store.js'

import Welcome from './components/Welcome.vue'
import TankParameters from './components/TankParameters.vue'
import ShrimpSelector from './components/ShrimpSelector.vue'
import Summary from './components/Summary.vue'

Vue.use(VueRouter)
Vue.config.productionTip = false

const routes = [
  {
    path: '/', component: Welcome
  },
  {
    path: '/tank-parameters', component: TankParameters
  },
  {
    path: '/shrimp-select', component: ShrimpSelector
  },
  {
    path: '/summary', component: Summary
  },
  {
    path: '/summary/:tankParams/:shrimpIds', component: Summary
  }
]

const router = new VueRouter({
  routes,
  base: process.env.BASE_URL
})

Vue.use(VueAnalytics, {
  id: 'UA-43257989-3',
  router,
  debug: {
    enabled: process.env.NODE_ENV === 'development',
    trace: false,
    sendHitTask: process.env.NODE_ENV !== 'development',
  }
})

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
